import { useState, VFC } from 'react'
import { invalidateUser } from 'src/api/user'
import { ATTENTION_1, ATTENTION_2, ATTENTION_3 } from 'src/assets/images'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import styled from 'styled-components'
import { Button, ButtonsDiv, CancelButton, Layout } from './styles'

const Attention: VFC<
  ModalProps<{ send: (noAttention?: boolean) => Promise<any> }>
> = ({ send, close }) => {
  const [noAttention, setNoAttention] = useState<boolean>()
  return (
    <Layout>
      <h3>メッセージ送信前の注意事項</h3>
      <Attentions>
        <div>
          <img src={ATTENTION_1} alt="" />
          <p>一方的な営業文面のメッセージは禁止です。</p>
        </div>
        <div>
          <img src={ATTENTION_2} alt="" />
          <p>メッセージ内容は運営が監視しております。</p>
        </div>
        <div>
          <img src={ATTENTION_3} alt="" />
          <p>不適切なメッセージは通報され退会処分になる場合もございます。</p>
        </div>
      </Attentions>
      <Check>
        <label>
          <input
            type="checkbox"
            checked={noAttention}
            onChange={({ target: { checked } }) => setNoAttention(checked)}
          />
          今後一週間この画面を非表示にする
        </label>
      </Check>
      <ButtonsDiv>
        <CancelButton onClick={close}>入力画面に戻る</CancelButton>
        <Button
          onClick={async () => {
            await send(noAttention)
            if (noAttention) invalidateUser()
            close()
          }}
        >
          このまま送信する
        </Button>
      </ButtonsDiv>
    </Layout>
  )
}

export const AttentionModal = asModal(Attention)

const Attentions = styled.div`
  display: flex;
  > div {
    width: 280px;
    margin: 24px;
    img {
      width: 100%;
    }
  }
`
const Check = styled.div`
  display: flex;
  justify-content: center;
  input {
    margin-right: 4px;
  }
`
